import { DEFAULT_ORGANISATION_PLAN_LIMITS, DEFAULT_USER_PLAN_LIMITS } from './plans';

export const PILOT_MODE = true;

export const PILOT_LIMITS = {
  // Upload limits in Pilot mode
  PDF_MAX_SIZE_MB: 25,
  WORD_MAX_SIZE_MB: 25,
  MAX_DOCUMENTS_PER_GENERATION: 1,
  SOURCE_SET_MAX_DOCUMENTS_PER_SUMMARY: 5,

  // Generation quotas
  GENERATIONS_PER_USER_PER_DAY: 100,
  GENERATIONS_PER_ORG_PER_DAY: 1000,
  ACTIVE_GENERATIONS_PER_USER: 5,

  // Feature-level AI usage limits for controlled pilot cost protection
  ASK_SOURCE_PER_USER_PER_DAY: DEFAULT_USER_PLAN_LIMITS.askSourcePerDay,
  ASK_SOURCE_PER_ORG_PER_DAY: DEFAULT_ORGANISATION_PLAN_LIMITS.askSourcePerDay,
  SOURCE_SUMMARIES_PER_USER_PER_DAY: DEFAULT_USER_PLAN_LIMITS.sourceSummariesPerDay,
  SOURCE_SUMMARIES_PER_ORG_PER_DAY: DEFAULT_ORGANISATION_PLAN_LIMITS.sourceSummariesPerDay,
  CREATE_LEARNING_PER_USER_PER_DAY: DEFAULT_USER_PLAN_LIMITS.createLearningPerDay,
  CREATE_LEARNING_PER_ORG_PER_DAY: DEFAULT_ORGANISATION_PLAN_LIMITS.createLearningPerDay,

  // Processing bounds
  TIMEOUT_MINUTES: 15, // 15 minutes max
};
